// @ts-strict-ignore
import type { Module } from 'vuex'

import type { AnalyticsState } from '../../models'

import { ResetAction } from '../common/actions/reset.action'
import { ResetMutation } from '../common/mutations/reset.mutation'

import { FetchStatsReportAction } from './actions/fetch-stats-report.action'
import { LoadDistDataAction } from './actions/load-dist-data.action'
import { LoadPivotDataAction } from './actions/load-pivot-data.action'
import { LoadQueriesDataAction } from './actions/load-queries-data.action'
import { LoadRelatedDataAction } from './actions/load-related-data.action'
import { LoadSearchDataAction } from './actions/load-search-data.action'
import { LoadSessionsDataAction } from './actions/load-sessions-data.action'
import { SetSelectedIdAction } from './actions/set-selected-id.action'
import { ANALYTICS_CONSTS } from './analytics.consts'
import { DataGetter } from './getters/data.getter'
import { SelectedIdGetter } from './getters/selected-id.getter'
import { SetDistDataMutation } from './mutations/set-dist-data.mutation'
import { SetPivotDataMutation } from './mutations/set-pivot-data.mutation'
import { SetQueriesDataMutation } from './mutations/set-queries-data.mutation'
import { SetRelatedDataMutation } from './mutations/set-related-data.mutation'
import { SetSearchDataMutation } from './mutations/set-search-data.mutation'
import { SetSelectedIdMutation } from './mutations/set-selected-id.mutation'
import { SetSessionsDataMutation } from './mutations/set-sessions-data.mutation'

export const ANALYTICS_MODULE: Module<AnalyticsState, any> = {
  namespaced: true,

  initialState: (): AnalyticsState => ({
    data: {
      overall: {
        dist: {
          currentPeriod: undefined,
        },
        pivots: {},
        sessions: {
          currentPeriod: undefined,
        },
      },
      queries: {},
      ids: {},
      search: {},
    },
    selectedId: undefined,
  }),
  state: (): AnalyticsState => ANALYTICS_MODULE.initialState(),

  getters: {
    [ANALYTICS_CONSTS.getters.data]: DataGetter.execute,
    [ANALYTICS_CONSTS.getters.selectedId]: SelectedIdGetter.execute,
  },

  actions: {
    [ANALYTICS_CONSTS.actions.loadDistData]: LoadDistDataAction.execute,
    [ANALYTICS_CONSTS.actions.loadPivotData]: LoadPivotDataAction.execute,
    [ANALYTICS_CONSTS.actions.loadSessionsData]: LoadSessionsDataAction.execute,
    [ANALYTICS_CONSTS.actions.loadQueriesData]: LoadQueriesDataAction.execute,
    [ANALYTICS_CONSTS.actions.loadRelatedData]: LoadRelatedDataAction.execute,
    [ANALYTICS_CONSTS.actions.loadSearchData]: LoadSearchDataAction.execute,

    [ANALYTICS_CONSTS.actions.setSelectedId]: SetSelectedIdAction.execute,

    [ANALYTICS_CONSTS.actions.fetchStatsReport]: FetchStatsReportAction.execute,

    [ANALYTICS_CONSTS.actions.reset]: context =>
      ResetAction.execute(context, ANALYTICS_MODULE.initialState()),
  },

  mutations: {
    [ANALYTICS_CONSTS.mutations.setDistData]: SetDistDataMutation.execute,
    [ANALYTICS_CONSTS.mutations.setPivotData]: SetPivotDataMutation.execute,
    [ANALYTICS_CONSTS.mutations.setSessionsData]: SetSessionsDataMutation.execute,
    [ANALYTICS_CONSTS.mutations.setQueriesData]: SetQueriesDataMutation.execute,
    [ANALYTICS_CONSTS.mutations.setRelatedData]: SetRelatedDataMutation.execute,
    [ANALYTICS_CONSTS.mutations.setSearchData]: SetSearchDataMutation.execute,

    [ANALYTICS_CONSTS.mutations.setSelectedId]: SetSelectedIdMutation.execute,

    [ANALYTICS_CONSTS.mutations.reset]: ResetMutation.execute,
  },
}
